// MOXIE: keyboard access for desktop nav submenus
// In hover mode, hdt-header-menu._onSummaryClicked navigates to data-url on any click
// (including keyboard-triggered synthetic clicks). We intercept Enter/Space in capture
// phase, prevent the synthetic click, and open via toggle() which dispatches 'pick'
// with offClick:true — skipping the navigation branch.
(function () {
  'use strict';

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    var summary = e.target.closest && e.target.closest('hdt-header-menu > details > summary');
    if (!summary) return;

    var menuEl = summary.closest('hdt-header-menu');
    // menuEl.event respects hover-detection logic built into the element
    if (!menuEl || menuEl.event !== 'hover') return;

    e.preventDefault();

    var wasOpen = menuEl.open;
    menuEl.toggle(!wasOpen);

    if (!wasOpen) {
      // Focus first item in submenu after opening animation begins
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var first = menuEl.querySelector(
            '.hdt-sub-menu a[href], .hdt-sub-menu summary, .hdt-sub-menu button'
          );
          if (first) first.focus();
        });
      });
    }
  }, true);

  // Cierra el megamenú hover cuando el foco sale del panel por teclado
  document.addEventListener('focusout', function (e) {
    var menuEl = e.target.closest('hdt-header-menu');
    if (!menuEl || !menuEl.open) return;
    if (menuEl.event !== 'hover') return;
    if (!e.relatedTarget || !menuEl.contains(e.relatedTarget)) {
      menuEl.toggle(false);
    }
  });

})();
